/* eslint no-console:0 */

// Rails Unobtrusive JavaScript (UJS) is *required* for links in Lucky that use DELETE, POST and PUT.
// Though it says "Rails" it actually works with any framework.
import Rails from "@rails/ujs";
import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import { app, MONTH_NAMES, MONTH_SHORT_NAMES, DAYS } from "./datepicker";

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Rails.start();

import "@hotwired/turbo"

import "@material-tailwind/html/scripts/ripple";
import "@material-tailwind/html/scripts/dialog";

import setupEditor from "./ckeditor"

import {initMap} from "./map"

import setupPond from "./filepond"

// import { Datepicker, Select, Input, initTE } from "tw-elements";
// initTE({ Datepicker, Select, Input });

window.Alpine = Alpine
window.datepicker = app
window.MONTH_NAMES = MONTH_NAMES
window.MONTH_SHORT_NAMES = MONTH_SHORT_NAMES
window.DAYS = DAYS
window.Swiper = {Swiper, Navigation, Pagination}

Alpine.plugin(persist)
Alpine.start()

// setupEditor();
// initMap()

window.addEventListener('turbo:load', () => {
    setupEditor();
    initMap()
    setupPond()
})